import { motion } from "framer-motion";

function Maps() {
  return (
    <section
      id="maps"
      className="relative h-auto flex items-center bg-white flex-col"
    >
      <div className="absolute inset-0 z-0 opacity-80 blur-xs">
        <img src="https://i.ibb.co/HfpTgZ19/tools11.jpg" alt="" className="w-full h-full object-cover" />
      </div>
      <motion.div
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 1 }}
        className="relative">
        <div className="p-10 flex w-full justify-center items-center text-center">
          <p className="text-2xl md:text-4xl text-white bg-black/30 p-5 rounded-4xl">KUNJUNGI TOKO KAMI DI SINI</p>
        </div>
        <div className="w-full flex flex-col md:flex-row items-center justify-center">
          <div className="hidden md:block w-[40%]">
            <img
              src="https://i.ibb.co/DgGj1RT2/womanpointing-min.png"
              alt=""
              className="w-full h-auto"
            />
          </div>

          <div className="w-full md:w-[60%] p-5">
            <div className="relative w-full h-[70vh] md:h-[400px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3965.716495291669!2d106.67631767482983!3d-6.300933593688204!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69fbc3ff1d8141%3A0xdc003aae8e83a615!2sTOKO%20BANGUNAN%20BUMI%20SERPONG!5e0!3m2!1sen!2sid!4v1749128796577!5m2!1sen!2sid"
                className="absolute top-0 left-0 w-full h-full border-0"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Google Map"
              />
            </div>
          </div>
        </div>
      </motion.div>
    </section>
  );
}

export default Maps;
